// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__1X8Ce","modal":"modal_modal__12G7x"};